import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-page"
};
import { remove } from '@/api/system/department';
import { deleteBox, toast } from '@/utils/message';
import { renderAddForm } from './add';
import { renderEditForm } from './edit';
import { createTable } from './table';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Department',
  setup(__props) {
    const tableRef = ref();
    const addRef = ref();
    const editRef = ref();
    let table = null;
    let addForm = null;
    let editForm = null;
    onMounted(() => {
      table = createTable(tableRef.value, {
        rowAdd,
        rowDelete,
        rowEdit
      }, {
        addFn,
        searchFn
      });
      addForm = renderAddForm(addRef.value);
      editForm = renderEditForm(editRef.value);
      editForm.onSaveSuccess = () => {
        table?.load();
      };
      addForm.onSaveSuccess = () => {
        table?.load();
      };
      table.load();
    });
    function rowAdd(row) {
      addForm?.open({
        parentId: row.id,
        sort: 0
      });
    }
    function rowEdit(row) {
      editForm?.open(row.id);
    }
    function rowDelete(row) {
      deleteBox().then(() => {
        remove([row.id]).then(() => {
          toast.success('删除成功');
          table?.load();
        });
      });
    }
    function addFn() {
      addForm?.open({
        sort: 0
      });
    }
    function searchFn() {
      table?.load();
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "table",
        style: {
          "height": "100%"
        },
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "addRef",
        ref: addRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "editRef",
        ref: editRef
      }, null, 512)]);
    };
  }
});